import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import { AuthRequestDetail, ChangePasswordDetails, DeeplinkDto,
  GoogleAuthPayload, SSOLogin, Token } from '../models/authModel';
import actionTypes from '../types/authTypes';

export const authStart = (): Action<void> => updateAction(actionTypes.AUTH_START);

export const authSuccess = (token?: any): Action<Token> =>
  updateAction(actionTypes.AUTH_SUCCESS, { token });

export const authFail = (error: Error | string): Action<Error | string> =>
  updateAction(actionTypes.AUTH_FAIL, error);

export const passwordExpired = (isPasswordExpired: any): Action<Error | string> =>
  updateAction(actionTypes.AUTH_PASSWORD_EXPIRED, isPasswordExpired);

export const logout = (): Action<void> => updateAction(actionTypes.AUTH_INITIATE_LOGOUT);

export const logoutSucceed = (): Action<void> => updateAction(actionTypes.AUTH_LOGOUT);

export const auth = (userName: string, password: string, onTwoFactorAuth: any, isChangePassword?: any): Action<AuthRequestDetail> =>
  updateAction(actionTypes.AUTH_USER, { userName, password, onTwoFactorAuth, isChangePassword });

export const setAuthDetails = (userName: string, password: string): Action<AuthRequestDetail> =>
  updateAction(actionTypes.AUTH_DETAILS, { userName, password });

export const otpLogin = (encryptedToken: string, otp: any): Action<any> =>
  updateAction(actionTypes.OTP_LOGIN, { encryptedToken, otp });

export const setUserAuthData = (providerDetail: any): Action<any> =>
  updateAction(actionTypes.SET_USER_AUTH_DATA, { providerDetail });

export const setEncryptedToken = (encryptedToken: string): Action<any> =>
  updateAction(actionTypes.SET_ENCRYPTED_TOKEN, encryptedToken);

export const setAuthRedirectPath = (path: string): Action<string> => updateAction(actionTypes.SET_AUTH_REDIRECT_PATH, path);

export const authCheckState = (): Action<void> => updateAction(actionTypes.AUTH_CHECK_STATE);
export const onDismisError = (): Action<void> => updateAction(actionTypes.CLEAR_AUTH_ERROR);

export const changePassword = (userName: string, newPassword: string, oldPassword: string,
  onSuccess: any = (): any => { }): Action<ChangePasswordDetails> =>
  updateAction(actionTypes.CHANGE_PASSWORD, { userName, oldPassword, newPassword, onSuccess });

export const ssoLogin = (token: string): Action<SSOLogin> =>
  updateAction(actionTypes.SSO_LOGIN, { token });

export const searchHospitals = (searchString: string, onSuccess: any = (): any => { }, onFailure: any = (): any => { }): Action<any> =>
  updateAction(actionTypes.SEARCH_HOSPITALS, { searchString, onSuccess, onFailure });

export const getHospDetail = (entityId: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.GET_HOSP_DETAIL, { entityId, onSuccess, onError });

export const getHospDetailPayer = (entityId: any): Action<any> =>
  updateAction(actionTypes.GET_HOSP_DETAIL_PAYER, { entityId });

export const setFreshBotInit = (isFreshBotInit: boolean): Action<any> =>
  updateAction(actionTypes.SET_FRESH_BOT_INIT, isFreshBotInit);

export const getSurveyQuestions = (providerId: any): Action<any> =>
  updateAction(actionTypes.GET_SURVEY_OPTIONS, providerId);

export const getSurveyQuestionsSuccess = (surveyQuestions: object): Action<any> =>
  updateAction(actionTypes.GET_SURVEY_OPTIONS_SUCCESS, surveyQuestions);

export const saveSurvey = (payload: object): Action<any> =>
  updateAction(actionTypes.SAVE_SURVEY, payload);

export const saveSurveySuccess = (payload: object): Action<any> =>
  updateAction(actionTypes.SAVE_SURVEY_SUCCESS, payload);

export const getUserPerformance = (payload: any): Action<any> =>
  updateAction(actionTypes.GET_USER_PERFORMANCE, payload);

export const getUserPerformanceSuccess = (payload: any): Action<any> =>
  updateAction(actionTypes.GET_USER_PERFORMANCE_SUCCESS, payload);

export const incorrectEmail = (payload: any, onSuccess: any): Action<any> =>
  updateAction(actionTypes.INCORRECT_EMAIL, { payload, onSuccess });

export const skippedEmailVerification = (payload: any, onSuccess: any): Action<any> =>
  updateAction(actionTypes.SKIPPED_EMAIL_VERIFICATION, { payload, onSuccess });

export const correctEmail = (payload: any, onSuccess: any): Action<any> =>
  updateAction(actionTypes.CORRECT_EMAIL, { payload, onSuccess });

export const emailVerificationVerifyOtp = (payload: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.EMAIL_VERIFICATION_VERIFY_OTP, { payload, onSuccess, onError });

export const getHipIdData = (providerId: any): Action<any> =>
  updateAction(actionTypes.GET_HIP_HIU, providerId);

export const setOtpFlowLoader = (loading: boolean): Action<any> =>
  updateAction(actionTypes.SET_OTP_FLOW_LOADER, loading);

export const googleAuth = (payload: GoogleAuthPayload): Action<any> =>
  updateAction(actionTypes.GOOGLE_AUTHENTICATE, payload );

export const setDeeplinkDto = (deeplinkDto: DeeplinkDto): Action<any> =>
  updateAction(actionTypes.SET_DEEPLINK_DTO, deeplinkDto);

export const setOtpTimerLimit = (waitTimeToResendOTPInSec: string): Action<any> =>
  updateAction(actionTypes.SET_OTP_TIMER_LIMIT, waitTimeToResendOTPInSec);

export const setIsOtpLimitExhausted = (isOTPRequestLimitExhausted: string): Action<any> =>
  updateAction(actionTypes.SET_IS_OTP_REQUEST_LIMIT_EXHAUSTED, isOTPRequestLimitExhausted);
